import React, { useState } from 'react';
import ReactPlayer from "react-player";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton
} from 'react-share';
interface VideoPlayerProps{
   title?:string;
   description?:string;
   videoLink:string;
   controls: boolean;
   isExternal: boolean;
}
const VideoPlayer = ({ title,
    description,
    videoLink,
    controls,
    isExternal }: VideoPlayerProps) => {
    const [showShare, setShowShare] = useState(false);
    const [showShareButton, setShowShareButton] = useState(false);
    const handleMouseEnter = () => {
        if (isExternal) {
            setShowShareButton(true);
        }
    };
    const handleMouseLeave = () => {
        if (isExternal && showShareButton) {
            setShowShareButton(false);
            setShowShare(false);
        }
    };
    return(
        <>              
            <div className='player-container-box'>
                <div className='player-frame'>
                    <div className='player-wrapper'>
                        <ReactPlayer className='react-player'                                
                            url={videoLink}
                            controls={controls}
                            width='100%'
                            height='100%'
                        />
                    </div>
                    {isExternal && (
                        <button
                            onClick={() => setShowShare(!showShare)}
                            style={{
                                position: 'absolute',
                                top: '40px',
                                right: '50px',
                                background: 'transparent',
                                border: 'none',
                                color: 'white',
                                width: '50px',
                                height: '50px',
                                cursor: 'pointer',
                                fontSize: '16px',
                            }}
                        >
                        </button>
                    )}
                    {showShare && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '104px',
                                right: '46px',
                                background: '#003778',
                                borderRadius: '12px',
                                padding: '10px',
                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                            }}
                        >
                            <FacebookShareButton url={videoLink}>
                                <p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_8759_13240)">
                                        <path d="M12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12C24 5.37264 18.6274 0 12 0Z" fill="white"></path>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_8759_13240">
                                            <rect width="24" height="24" fill="white"></rect>
                                        </clipPath>
                                    </defs>
                                </svg></p>
                            </FacebookShareButton>
                            <TwitterShareButton url={videoLink}>
                                <p><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M18.3263 1.90381H21.6998L14.3297 10.3273L23 21.7898H16.2112L10.894 14.8378L4.80995 21.7898H1.43443L9.31743 12.7799L1 1.90381H7.96111L12.7674 8.25814L18.3263 1.90381ZM17.1423 19.7706H19.0116L6.94539 3.81694H4.93946L17.1423 19.7706Z" fill="white"></path>
                                </svg></p>
                            </TwitterShareButton>
                            <LinkedinShareButton url={videoLink}>
                                <p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_8759_13248)">
                                            <path d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z" fill="white"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_8759_13248">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </p>
                            </LinkedinShareButton>                            
                        </div>
                    )} 
                </div>
            </div>                                  
        </>
    );    
};

export default VideoPlayer;